// Header Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import DateUtil from '../../../lib/dateutil.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class Header extends Component {
  constructor (props) {
    super(props)

    this.dayNames = DateUtil.getDayNames()
  }

  static get propTypes () {
    return {
      date: PropTypes.number,
      prevMonth: PropTypes.func,
      nextMonth: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      date: 0,
      prevMonth: null,
      nextMonth: null
    }
  }

  shouldComponentUpdate (nextProps) {
    return nextProps.date !== this.props.date
  }

  render () {
    const date = new Date(this.props.date)

    /* eslint-disable react/jsx-handler-names */
    return (
      <div className='calendar__header'>
        <div className='calendar__month-chooser'>
          <span className='title'>
            <IntlMessage ident='common.form.datePeriodLabel' />
          </span>
          <div className='action'>
            <span
              className='calendar__prev-month'
              onClick={this.props.prevMonth}
            >
              <i className='icon icon-calendar-previous' />
            </span>
            <span className='month'>{DateUtil.getDisplayMonth(date)}</span>
            <span
              className='calendar__next-month'
              onClick={this.props.nextMonth}
            >
              <i className='icon icon-calendar-next-active' />
            </span>
          </div>
        </div>
        <table className='calendar__days-names' cellSpacing='0'>
          <tbody>
            <tr>
              {this.dayNames.map((i, key) => (
                <td className='calendar__day-name' key={key}>
                  {i}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    )
    /* eslint-enable react/jsx-handler-names */
  }
}

export default Header
